// Firebase ID tokens expire after 60 minutes; refresh well before that to leave
// room for a slow connection at the store.
export const TOKEN_MAX_AGE_MS = 600000;

// Shorter than TOKEN_MAX_AGE_MS: a tick just before the window would delay the refresh a full period.
export const TOKEN_CHECK_MS = TOKEN_MAX_AGE_MS / 2;

// A failed refresh logs the KDS out via withPostFailure, so never try while offline.
export const shouldRefreshToken = ({ isOnline, lastRefreshAt, now }) => {
  if (!isOnline) return false;
  if (!Number.isFinite(lastRefreshAt) || lastRefreshAt <= 0) return true;
  return now - lastRefreshAt >= TOKEN_MAX_AGE_MS;
};

export const shouldRefreshTokenOnResume = ({ isVisible, isOnline, lastRefreshAt, now }) =>
  Boolean(isVisible) && shouldRefreshToken({ isOnline, lastRefreshAt, now });
